import { ShoppingCart, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '@/context/CartContext';

export default function CartAddedToast() {
  const { lastAdded, itemCount } = useCart();
  if (!lastAdded) return null;

  return (
    <div
      data-testid="cart-added-toast"
      className="fixed top-24 right-4 sm:right-6 z-[100] animate-slide-up pointer-events-auto"
      role="status"
      aria-live="polite"
    >
      <Link
        to="/cart"
        className="flex items-center gap-3 bg-[#1A1A1A] text-white text-sm px-4 py-3 rounded-xl shadow-[0_12px_40px_-12px_rgba(0,0,0,0.5)] hover:bg-black transition-colors max-w-[340px]"
      >
        <span className="relative w-8 h-8 bg-[#FF2A2A] rounded-full flex items-center justify-center flex-shrink-0">
          <Check size={14} strokeWidth={3} className="text-white" />
        </span>
        <span className="flex-1 min-w-0">
          <span className="block text-[10px] font-bold tracking-[0.15em] uppercase text-[#FF2A2A]">Added to cart</span>
          <span className="block text-xs font-semibold truncate">{lastAdded}</span>
        </span>
        <span className="flex items-center gap-1.5 text-[11px] font-bold whitespace-nowrap bg-white/10 px-2.5 py-1 rounded-lg">
          <ShoppingCart size={12} /> {itemCount}
        </span>
      </Link>
    </div>
  );
}
